function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import LocaleKeys from '../../../../locales/keys';
import { i18n, LogHelper } from 'invision-core';
import { CurrentRedemptionDetailsSelector, SelectedReasonIdSelector } from '../../../../reducers/selectors/coupon.redemption.code.selectors';
import { removeCouponRedemptionCode, setSelectedReasonId } from '../../../../reducers/actions/coupon.redemption.code.actions';
import { NOTIFICATION_TIME_LENGTH } from '../../../../customercare.constants';
var RemoveCouponRedemptionCodeModalController = /*#__PURE__*/function () {
  function RemoveCouponRedemptionCodeModalController($ngRedux, $timeout, uiNotificationService) {
    _classCallCheck(this, RemoveCouponRedemptionCodeModalController);
    this.$ngRedux = $ngRedux;
    this.$timeout = $timeout;
    this.uiNotificationService = uiNotificationService;
    this.localeKeys = LocaleKeys;
  }
  return _createClass(RemoveCouponRedemptionCodeModalController, [{
    key: "$onInit",
    value: function $onInit() {
      var _this = this;
      var controllerActions = {
        removeCouponRedemptionCode: removeCouponRedemptionCode,
        setSelectedReasonId: setSelectedReasonId
      };
      var mapStateToTarget = function mapStateToTarget(store) {
        return {
          selectedCouponRedemptionCode: CurrentRedemptionDetailsSelector(store),
          selectedReasonId: SelectedReasonIdSelector(store)
        };
      };
      this.disconnectRedux = this.$ngRedux.connect(mapStateToTarget, controllerActions)(function (state, actions) {
        _this.state = state;
        _this.actions = actions;
      });
      this.formFieldLocaleKeyMapping = {
        reason: LocaleKeys.COUPONS.REDEMPTION_CODE_DETAILS.MODALS.ERRORS.REMOVE_REASON_REQUIRED
      };
    }
  }, {
    key: "onReasonSelected",
    value: function onReasonSelected(selectedReason) {
      this.actions.setSelectedReasonId(selectedReason && selectedReason.id);
    }
  }, {
    key: "onSubmitForm",
    value: function onSubmitForm() {
      var _this2 = this;
      if (this.removeForm.$invalid) {
        return;
      }
      if (this.awaitingAsyncOperation) {
        LogHelper.warn('Remove coupon redemption code request submitted while awaiting pre-existing async op');
        return;
      }
      if (this.state.selectedReasonId) {
        this.awaitingAsyncOperation = true;
        var couponRedemptionCodeUpdated = false;
        var couponRedemptionCodeId = this.state.selectedCouponRedemptionCode.RedemptionCode.Id;
        var reasonId = parseInt(this.state.selectedReasonId, 10);
        this.actions.removeCouponRedemptionCode(couponRedemptionCodeId, reasonId).then(function () {
          couponRedemptionCodeUpdated = true;
          _this2.uiNotificationService.success(i18n.translate(_this2.localeKeys.COUPONS.REDEMPTION_CODE_DETAILS.LABELS.REMOVE_SUCCESS_MESSAGE), null, {
            timeOut: NOTIFICATION_TIME_LENGTH
          });
          _this2.handleClose(couponRedemptionCodeUpdated);
        }).catch(function (error) {
          _this2.handleClose(couponRedemptionCodeUpdated, error);
        }).finally(function () {
          _this2.awaitingAsyncOperation = false;
        });
      }
    }
  }, {
    key: "handleClose",
    value: function handleClose(paymentMethodUpdated, error) {
      // Call the onClose callback passed to the component
      this.onClose()(paymentMethodUpdated, error);
    }
  }, {
    key: "$onDestroy",
    value: function $onDestroy() {
      this.disconnectRedux();
    }
  }]);
}();
export default {
  bindings: {
    onClose: '&'
  },
  template: require('./remove.redemption.code.modal.html'),
  controller: RemoveCouponRedemptionCodeModalController
};